import { render, staticRenderFns } from "./ManageCourseInstructor.vue?vue&type=template&id=0f468686&"
import script from "./ManageCourseInstructor.vue?vue&type=script&lang=js&"
export * from "./ManageCourseInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports